import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {ModalForm} from "~/components";
import {SelectField} from "~/components/Forms";

const OPTIONS = [
	{value: 'off', label: 'Tắt (không gửi báo cáo)'},
	{value: 'daily', label: 'Hằng ngày'},
	{value: 'weekly', label: 'Hằng tuần'},
	{value: 'monthly', label: 'Hằng tháng'},
];

/**
 * Modal cấu hình báo cáo email định kỳ của dự án (#22 Reporting). Chỉ chọn TẦN SUẤT;
 * nội dung báo cáo dựng tự động từ dữ liệu các tool đã chạy (crawl/GSC/GA/PageSpeed).
 */
function ReportScheduleForm({open, submitting, current, onCancel, onSubmit}) {

	const {control, handleSubmit, reset} = useForm({
		defaultValues: {schedule: current || 'off'},
	});

	useEffect(() => {
		if (open) reset({schedule: current || 'off'});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-envelope-open-text"
			title="Báo cáo email định kỳ"
			subtitle="Tự động gửi tổng hợp SEO của dự án vào hộp thư theo chu kỳ"
			onCancel={onCancel}
			onOk={handleSubmit((v) => onSubmit(v.schedule))}
			okText="Lưu lịch"
			loading={submitting}
		>
			<Controller control={control} name="schedule" render={({field}) => (
				<SelectField
					label="Tần suất gửi báo cáo"
					options={OPTIONS}
					style={{width: '100%'}}
					{...field}
				/>
			)} />
			<p style={{fontSize: 13, color: '#6b7280', marginTop: 4}}>
				Báo cáo gồm điểm Site Crawler, số liệu Search Console / Analytics của kỳ
				(so sánh với kỳ liền trước) và điểm PageSpeed — chỉ tổng hợp dữ liệu đã có,
				không chạy lại tool. Dự án chưa có dữ liệu sẽ không nhận mail rỗng.
			</p>
		</ModalForm>
	);
}

export default ReportScheduleForm;
